<template>
  <div>
    <section class="wrapper">
      <!-- start: pc GNB-->
      <header class="header">
        <div class="inner">
          <div class="wrap-basic">
            <div class="flex-wrap">
              <div class="col lf-col">
                <div class="drop-down ui-js-dropdown">
                    <div class="tt-area">
                        <h2 class="view">
<!--                          <span v-show="localeLanguage === 'mn'">-->
<!--                            <span class="flag mo"></span> Монгол <i class="arrow"></i>-->
<!--                          </span>-->
                          <span v-show="localeLanguage === 'ko'">
                            <span class="flag kr"></span> 한국어 <i class="arrow"></i>
                          </span>
                          <span v-show="localeLanguage === 'en'">
                            <span class="flag en"></span> English <i class="arrow"></i>
                          </span>                        
                        </h2>
                    </div>
                    <ul class="drp-down-box">
                        <li>
                          <a  @click="changeLocale('en')">
                            <span class="flag en"></span> English <i class="arrow"></i>
                          </a>
                        </li>
<!--                        <li>-->
<!--                          <a  @click="changeLocale('mn')">-->
<!--                            <span class="flag mo"></span> Монгол <i class="arrow"></i>-->
<!--                          </a>-->
<!--                        </li>-->
                        <li><a  @click="changeLocale('ko')">
                          <span class="flag kr"></span> 한국어 <i class="arrow"></i></a>
                        </li> 
                    </ul>
                </div>
              </div>
              <div class="col md-col">
                <a href="/"><img src="@/assets/img/common/logo.png" alt="일산차병원"/></a>
              </div>
              <div class="col rt-col">
                <ul class="util-box" v-if="!hasSession">
                  <li class="it">
                    <router-link to="/login">{{ t("로그인") }}</router-link>
                  </li>
                  <li class="it">
                    <router-link to="/signup">{{ t("회원가입") }}</router-link>
                  </li>
                </ul>
                <ul class="util-box" v-else>
                  <li class="it">
                    <router-link to="/profile">
                      <span class=""></span> {{ user.name }}
                    </router-link>
                  </li>
                  <li class="it"><a href="#" @click.prevent="logout">{{ t("로그아웃") }}</a></li>
                </ul>
              </div>
            </div>
          </div>
          <nav>
              <ul class="navi">
                  <li class="item">
                      <a href="#;">{{ t("상담/진료") }}</a>
                  </li>
                  <li class="item">
                      <a href="#;">{{ t("고객센터") }}</a>
                  </li>
                  <li class="item">
                      <a href="#;">{{ t("건강매거진") }}</a>
                  </li>
                  <li class="item">
                      <a href="#;">{{ t("소개") }}</a>
                  </li>
              </ul>
              <div class="drop-snb">
                  <div class="inner">
                      <h2> {{ t("상담/진료") }}</h2>
                      <ul class="sub-list">
                        <li>
                          <a href="/applyCounselling">{{ t("상담신청") }}</a>
                        </li>
                        <li>
                          <a href="/applySecondOpinion">{{ t("2차소견 신청") }}</a>
                        </li>
                          <li><a href="/howToTreatment">{{ t("진료절차") }}</a></li>
                      </ul>
                      <h2> {{ t("고객센터") }} </h2>
                      <ul class="sub-list">
                        <li>
                          <a href="/counsellingList">
                            {{ t("상담") + "/" + t("진료") + "/" + t("2차 소견") }}
                          </a>
                        </li>
                        <li>
                          <a href="/medicalFileList">{{ t("의료정보 관리") }}</a>
                        </li>
                        <li>
                          <a href="/paymentList">{{ t("진료비 결제") }}</a>
                        </li>
                        <li>
                          <a href="/customerInquiryList"> {{ t("고객문의") }}</a>
                        </li>
                      </ul>
                      <h2>{{ t("건강매거진") }}</h2>
                      <ul class="sub-list">
                          <li><a href="/healthMagazineHealth">{{ t("건강매거진") }}</a></li>
                      </ul>
                      <h2>{{ t("소개") }}</h2>
                      <ul class="sub-list">
                          <li><router-link to="/CHAGroup/introduce">{{ t("CHA 그룹 소개") }}</router-link></li>
                          <li><router-link to="/CHAHospital/ilsanHospital">{{ t("병원 소개") }}</router-link></li>
                          <li><router-link to="/CHADepartment/infertility">{{ t("진료과 소개") }}</router-link></li>
                          <li><router-link to="/CHADoctor/FieldInfertility">{{ t("의사 소개") }}</router-link></li>
                      </ul>
                  </div>
              </div>
          </nav>
        </div>
      </header>
      <!-- // End -->
      
      <!-- start: mo GNB-->
      <header class="mo-header">
        <div class="inner wrap-basic">
          <div class="flex-wrap">
            <div class="col lf-col">
              <a href="#"><img src="@/assets/img/common/logo.png" alt="일산차병원"/></a>
            </div>
            <div class="col rt-col">
              <button type="button" class="hamberger">메뉴</button>
            </div>
          </div>
        </div>
        <div class="fixed-navi">
          <div class="inn">
            <div class="box top">
              <template v-if="!hasSession">
                <h2>
                  <strong><router-link to="/login">{{ t("로그인을 해주세요.") }}</router-link></strong>
                </h2>
                <router-link to="/signup">{{ t("아직 회원이 아니신가요?") }}</router-link>
                <button type="button" class="close-btn"></button>
              </template>
              <template v-else>
                <h2>
                  <strong>{{ user.name }}</strong>{{ t("님 반갑습니다.") }}
                  <a href="#" @click.prevent="logout">{{ t("로그아웃") }}</a>
                </h2>
                <button type="button" class="close-btn"></button>
              </template>
            </div>
            <div class="box middle">
              <div class="my-util">
                <ul class="ut-box">
                  <li><router-link to="/counsellingList"><span class="ico consulting"></span> {{ t("상담목록") }} </router-link></li>
                  <li><router-link to="/treatmentList"><span class="ico my-list"></span> {{ t("진료목록") }} </router-link></li>
                  <li><router-link to="/secondOpinionList"><span class="ico my-list2"></span> {{ t("2차소견 목록") }}</router-link></li>
                  <li><router-link to="/medicalFileList"><span class="ico my-info-list"></span> {{ t("내 의료정보 파일") }}</router-link></li>
                  <li><router-link to="/paymentList"><span class="ico my-payment"></span> {{ t("진료비 결제") }}</router-link></li>
                  <li><router-link to="/medicalInspectionRecordList"><span class="ico my-recod"></span> {{ t("의무기록") }} </router-link></li>
                  <li><router-link to="/customerInquiryList"><span class="ico customer"></span> {{ t("고객문의") }} </router-link></li>
                  <li><router-link to="/profile"><span class="ico my-page"></span> {{ t("회원정보") }} </router-link></li>
                </ul>
              </div>

              <div class="menu">
                  <ul class="navi">
                      <li class="item">
                          <button type="button" class="depth-1">{{ t("소개") }}<i class="arrow"></i></button>
                          <ul class="m-sub-gnb">
                              <li><router-link to="/CHAGroup/introduce">{{ t("CHA 그룹 소개") }}</router-link></li>
                              <li><router-link to="/CHAHospital/ilsanHospital">{{ t("병원소개") }}</router-link></li>
                              <li><router-link to="/CHADepartment/infertility">{{ t("진료과 소개") }}</router-link></li>
                              <li><router-link to="/CHADoctor/ilsanHospital">{{ t("의사 소개") }}</router-link></li>
                          </ul>
                      </li>
                      <li class="item">
                          <button type="button" class="depth-1">상담/진료 <i class="arrow"></i></button>
                          <ul class="m-sub-gnb">
                              <li><router-link to="/applyCounselling">{{ t("상담신청") }}</router-link></li>
                              <li><router-link to="/applySecondOpinion">{{ t("2차소견 신청") }}</router-link></li>
                              <li><router-link to="/howToTreatment">{{ t("진료절차") }}</router-link></li>
                          </ul>
                      </li>
                      <li class="item">
                          <button type="button" class="depth-1">고객센터 <i class="arrow"></i></button>
                          <ul class="m-sub-gnb">
                            <li>
                              <router-link to="/counsellingList">
                                {{ t("상담") + "/" + t("진료") + "/" + t("2차 소견") }}
                              </router-link>
                            </li>
                            <li>
                              <router-link to="/medicalFileList">{{ t("의료정보 관리") }}</router-link>
                            </li>
                            <li>
                              <router-link to="/paymentList">{{ t("진료비 결제") }}</router-link>
                            </li>
                            <li>
                              <router-link to="/customerInquiryList"> {{ t("고객문의") }}</router-link>
                            </li>
                          </ul>
                      </li>
                      <li class="item">
                          <button type="button" class="depth-1">{{ t("건강매거진") }} <i class="arrow"></i></button>
                          <ul class="m-sub-gnb">
                              <li><a href="/healthMagazineHealth">{{ t("건강매거진") }}</a></li>
                          </ul>
                      </li>
                  </ul>
              </div>
            </div>
            <div class="box bottom">
              <div class="lang-box">
                <div class="tt-area">
                  <h2 class="view">

<!--                    <span v-show="localeLanguage === 'mn'">-->
<!--                      <span class="flag mo"></span> Монгол <i class="arrow"></i>-->
<!--                    </span>-->
                    <span v-show="localeLanguage === 'ko'">
                      <span class="flag kr"></span> 한국어 <i class="arrow"></i>
                    </span>
                    <span v-show="localeLanguage === 'en'">
                      <span class="flag en"></span> English <i class="arrow"></i>
                    </span>       
                  </h2>
                </div>
                <div class="lang-ch-area">
                  <div class="inn">
<!--                    <div class="item">-->
<!--                      <button class="view"  @click="changeLocale('mn')"><span class="flag mo"></span> Монгол</button>-->
<!--                    </div>-->
                    <div class="item">
                        <button class="view"  @click="changeLocale('en')"><span class="flag en"></span> English</button>
                    </div>
                    <div class="item">
                        <button class="view" @click="changeLocale('ko')"><span class="flag kr"></span> 한국어</button>
                    </div>
                        <!-- <div class="item">
                            <button class="view"><span class="flag jp"></span> 日本語</button>
                        </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- // End -->
      
      <router-view @event-session-changed='sessionChanged'/>
      
      <footer>
        <div class="inner">
          <div class="bottom">
            <div class="wrap-basic">

              <p class="copyright mg top-15" style="font-size: 15px;">
                Contact us
              </p>

              <p class="dsc" style="font-size: 13px;">
                E-mail: globalcha@chamc.co.kr
              </p>
              <p class="dsc" style="font-size: 13px;">
                ENG +82-10-8866-2268 (available on what’s app) <br>
                RUS +82-10-5759-5003 (available on what’s app) <br>
                CHN +82-10-2810-8576 (available on wechat)
              </p>


              <!-- <p class="dsc">
                {{ t("경기도 고양시 일산동구 중앙로 1205 일산차병원 (대표전화 031-782-8300)") }}
              </p>
              <p class="dsc">
                1205, Jungang-ro, Ilsandong-gu, Goyang-si, Gyeonggi-do, Republic of Korea
              </p> -->


              <p class="copyright mg top-15">
                COPYRIGHT ⓒ 2019 CHAMC, ALL RIGHTS RESERVED.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </section>
    
    <div class="floating">
      <div class="top-button">
        <button type="button" class="">UP</button>
      </div>
    </div>
    
    <!-- start:레이어 팝업 -->
    <div class="popup-wrap"></div>
    <!-- //end:레이어 팝업 -->
  
  </div>
</template>
<script setup>
import { loadScript } from "vue-plugin-load-script"
import { inject, ref, onUpdated, onMounted, onBeforeUpdate, onBeforeMount } from "vue";
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex";
import { apiClient } from '@/http/apiClient'
import { useRouter, useRoute } from 'vue-router'

const store = useStore()
const localeLanguage = ref(store.getters["locale/getLocale"]);
const router = useRouter()
const route = useRoute()
const {t} = useI18n()
const i18n = inject('i18n')
const user = store.getters["auth/getuser"];

if(i18n.global.locale.value != localeLanguage.value){
  i18n.global.locale.value = localeLanguage.value
}

const changeLocale = (lang) => {
  router.replace({path: route.path, query:{
    ...route.query,
    lang : lang
  }})
  i18n.global.locale.value = lang
  store.dispatch("locale/saveLocale", {locale: lang});
  localeLanguage.value = lang;
}
const hasSession = ref(false)
hasSession.value = store.getters["auth/isLogined"];

const logout = async (event) => {
  event.preventDefault();
  
  try {
    await store.dispatch("auth/flush");
    await apiClient.get("/authentication/logout");
    hasSession.value = false;
    await window.open("/login", '_self').focus();
  } catch (error) {
    alert("로그아웃")
  }
};

const sessionChanged = () => {
  hasSession.value = store.getters["auth/isLogined"];
  
}

onUpdated(() => {
  window.reloadUIScript()
})

loadScript("/js/ui.dev.js");
loadScript("/js/popup.js");
</script>
